import store from '@/store'

export const ConditionsHelper = {
  loadConditionsContent({ language }) {
    const conditionsContent = store.getters['content/getContent']('conditions')
    const hasConditions = !!conditionsContent
    if (!hasConditions || conditionsContent.language !== language) {
      import(/* webpackChunkName: "lang-[request]" */ `@/language/conditions/conditions.${language}.json`).then(
        conditions => {
          const data = {
            language,
            ...conditions.default,
          }
          store.dispatch('content/setContent', {
            key: 'conditions',
            data,
          })
        }
      )
    }
  },
}
